/**
 * Builds the shareable standalone preview URL for a blog post. The preview
 * route lives outside the admin layout and opens with no login; unguessable
 * slugs are minted with `mintBlogPreviewSlug`.
 */
export const buildBlogPreviewUrl = (adminRoot: string, slug: string): string => {
  const root = adminRoot.replace(/\/+$/, '')
  return `${root}/blog-preview/${encodeURIComponent(slug)}`
}
